export const LabUnit = (props: { unit: string }) => {
    const { unit } = props;

    return (
        <span dangerouslySetInnerHTML={{ __html: unit }} />
    );
};
